import { render } from "./Goods.vue?vue&type=template&id=647ddabd&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=647ddabd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Z\\Desktop\\7\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647ddabd"]])

export default __exports__